var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"enrollment-mfe@0.1221.0"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/s/o/enrollment-mfe/v0.1221.0/534ddbcbe515a48bbb676ebd7355cb3919578f72";

// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import { Offline as OfflineIntegration } from '@sentry/integrations';
// @ts-ignore TypeScript is looking in the wrong file to know BrowserTracing is exported
import { BrowserTracing } from '@sentry/nextjs';
import { WINDOW_SENTRY_TRACE_TRANSACTION_KEY } from '@/constants';
import initSentry from './sentry.init';

const integrations = [new BrowserTracing(), new OfflineIntegration()];

initSentry({
  integrations,
  tracesSampler: (samplingContext) => {
    // always sample requests where the parent is being sampled
    if (samplingContext.parentSampled) {
      return 0.5;
    }
    if (window[WINDOW_SENTRY_TRACE_TRANSACTION_KEY] === true) {
      return 0.5;
    }
    return 0;
  },
  ignoreErrors: ['ResizeObserver loop completed with undelivered notifications.'],
});
